import * as React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { SIDEBAR_BG_DARK } from "../../settings/colors";
import { TOPBAR_HEIGHT } from "../../settings/metrics";

const logo = require("../../assets/logbook-logo.svg");

const BrandLinkWrapper = styled(Link)`
  line-height: 1;
  background: ${SIDEBAR_BG_DARK};
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 0 0 auto;
  height: ${TOPBAR_HEIGHT}px;
  padding: 0 16px;

  & > img {
    display: block;
    width: 179px;
    height: 20px;
  }
`;

const BrandLink = props => (
  <BrandLinkWrapper to="/" {...props}>
    <img src={logo} alt="Archadeck Logbook logo" />
  </BrandLinkWrapper>
);

export default BrandLink;



// WEBPACK FOOTER //
// ./src/components/sidebar/BrandLink.js